<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("financial.对账单管理筛选") }}
      </h6>
      <div class="mg-t-20 pd-x-10 mg-b-40">
        <div class="mg-b-10 form-group">
          <select-distributor
            class="mg-b-10"
            :noLike="true"
            :key_word="keySupplierName"
            @changeKeyword="changeName"
            @keywordEnter="filtrateName"
            @keywordFilter="filtrateNameDefault"
          />
        </div>
        <div class="mg-b-10 form-group">
          <input
            type="text"
            :placeholder="$t('financial.对账单编号')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model="keyBillCode"
          />
        </div>
        <div class="mg-b-10 form-group">
          <input
            type="text"
            :placeholder="$t('financial.采购单号')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model="keyOrderCode"
          />
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="keyStatus"
          >
            <option value="">{{ $t("financial.选择结算状态") }}</option>
            <template v-for="(status, index) in billStatusArr">
              <option v-if="index != '9'" :key="index" :value="index">
                {{ $t(status) }}
              </option>
            </template>
          </select>
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="keyType"
          >
            <option value="">{{ $t("financial.选择结算类型") }}</option>
            <option
              v-for="(status, index) in $dict.billType"
              :key="index"
              :value="index"
            >
              {{ $t(status) }}
            </option>
          </select>
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="keyHasSubBill"
          >
            <option value="">{{ $t("financial.是否只显示有子对账单") }}</option>
            <option :value="1">{{ $t("mall.是") }}</option>
            <option :value="2">{{ $t("mall.否") }}</option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary search btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate"
    >
      {{ $t("financial.筛 选") }}
    </button>
    <!-- todo3-对账单管理 -->
    <button
      @click="batchSearch('financial')"
      class="
        btn btn-primary batchSearch btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
    >
      {{ $t("distributor.批量搜索") }}
    </button>
  </div>
</template>

<script>
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索

export default {
  props: [
    "status",
    "bill_code",
    "order_code",
    "settlement_status",
    "supplier_name",
    "key_type",
    "key_hasSubBill",
  ],
  data() {
    return {
      billStatusArr: arrDict.billStatus,
      keySupplierName: "",
      keySupplierId: "",
      keySupplierName1: "",
      keySupplierId1: "",
      keyOrderCode: "",
      keyStatus: this.$route.query.status ? this.$route.query.status : "",
      keyBillCode: "",
      keyType: "",
      keyHasSubBill: "",
    };
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
  },
  watch: {
    key_hasSubBill() {
      this.keyHasSubBill = this.key_hasSubBill;
    },
    key_type: function () {
      this.keyType = this.key_type;
    },
    bill_code: function () {
      this.keyBillCode = this.bill_code;
    },
    order_code: function () {
      this.keyOrderCode = this.order_code;
    },
    settlement_status: function () {
      this.keyStatus = this.settlement_status;
    },
    supplier_name: function () {
      this.keySupplierName = this.supplier_name;
      this.keySupplierName1 = this.supplier_name;
    },
  },
  components: {
    "select-distributor": SelectDistributor,
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    sideChangeStatus() {
      //边栏状态改变
      this.$emit("changeStatus");
    },
    changeName(name, id) {
      console.log(id);
      this.keySupplierName = name;
      this.keySupplierId = id;
    },
    filtrateName(name, id) {
      //    if(name && name == this.supplier_name){
      //      this.filtrate();
      //      return;
      //    }
      console.log(id);
      if (!id || id == "e999") {
        ShowTip(this.$t("financial.没有匹配的供应商"), "danger");
        this.keySupplierName = "";
        this.keySupplierId = "";
      } else {
        //清空按供应商名
        this.keySupplierName = name;
        this.keySupplierId = id;
      }
      this.filtrate();
    },
    filtrateNameDefault(name, id) {
      this.keySupplierName1 = name;
      this.keySupplierId1 = id;
    },
    filtrate() {
      if (!this.keySupplierId) {
        this.keySupplierName = "";
        this.keySupplierId = this.keySupplierId1;
        this.keySupplierName = this.keySupplierName1;
        this.$emit(
          "filtrate",
          this.keyOrderCode,
          this.keyStatus,
          this.keySupplierName1,
          this.keySupplierId1,
          this.keyBillCode,
          this.keyType,
          this.keyHasSubBill
        );
      } else {
        if (!this.keySupplierId1) {
          this.$emit(
            "filtrate",
            this.keyOrderCode,
            this.keyStatus,
            this.keySupplierName,
            this.keySupplierId,
            this.keyBillCode,
            this.keyType,
            this.keyHasSubBill
          );
        } else {
          this.keySupplierName = "";
          this.keySupplierId = this.keySupplierId1;
          this.keySupplierName = this.keySupplierName1;
          this.$emit(
            "filtrate",
            this.keyOrderCode,
            this.keyStatus,
            this.keySupplierName1,
            this.keySupplierId1,
            this.keyBillCode,
            this.keyType,
            this.keyHasSubBill
          );
        }
      }
    },
  },
};
</script>

